<template>
    <div class="input-content">
        <div class="user-input-textarea-wrapper" ref="user-input-textarea-wrapper">
            <a-mentions
                rows="5"
                autoFocus
                v-model="prompt"
                :prefix="['/']"
                :disabled="typing"
                class="user-input-textarea" :placeholder="placeholder"
                @keydown.native.alt.enter.prevent="wrap"
                @select="selectValue"
                @blur="handleFocus(false)"
                @focus="handleFocus(true)"
                @keydown.native.enter.prevent.exact="ask"
                :getPopupContainer="() => $refs['user-input-textarea-wrapper']">
                <a-mentions-option :value="item.title" :key="item.value" v-for="item in mentionsList">
                    {{ item.title }}
                </a-mentions-option>
            </a-mentions>
        </div>
        <div class="textarea-right">
            <mic :prompt.sync="prompt"></mic>
            <img class="send" :class="{'disabled': !prompt}" src="@/theme/images/icons/icon_send.svg" @click="send()" title="发送" />
        </div>
    </div>
</template>

<script>
import mic from './mic.vue';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';
import { isJson } from '@/utils/json.js';
export default {
    name: 'gpt-chatbox-cop',
    components: { mic },
    data () {
        let { protocol, host } = window.location;
        return {
            prompt: '',
            recording: false,
            wsOPEX: `${protocol === 'https:' ? 'wss' : 'ws'}://${host}/chatgpt-server/websocket/`,
            MODEL_LIST,
            socket: null,
            isWait: false,
            interval: null,
            tempInput: '',
            title: '智能节能'
        };
    },
    props: {
        /**
         * 是否正在输入
         */
        typing: {
            type: Boolean,
            default: false
        },
        /**
         * 输入框的占位文字
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * 输入框的内容
         */
        input: {
            type: String,
            default: ''
        },
        /**
         * SessionID
         */
        sessionId: {
            type: String,
            default: ''
        },
        /**
         * 提示词模板的内容
         */
        promptTemplate: {
            type: Object,
            default: null
        }
    },
    computed: {
        mentionsList () {
            return [
                ...this.MODEL_LIST
            ];
        }
    },
    watch: {
        input (val) {
            this.prompt = val;
        },
        prompt (val) {
            if (val && val[0] === '/') {
                this.$emit('showModel');
            }
            if (val && val.indexOf('/?') > -1) {
                this.$bus.$emit('openAiModel');
                this.prompt = this.prompt.replace('/?', '');
            }
        }
    },
    mounted () {
        this.prompt = this.input;
        this.$bus.$on('newChat:reflash', (data) => {
            this.initSocket();
        });
        this.$bus.$on('shop:thisWs', (data) => {
            this.socket.close();
            this.prompt = '';
        });
    },
    methods: {
        handleFocus (focus) {
            this.$emit('focus-typing', focus);
        },
        send () {
            if (this.isSending) {
                return;
            }
            if (this.prompt.trim() === '') {
                this.$message.error('请输入内容后再发送');
                return;
            }

            this.isSending = true;
            this.tempInput = this.prompt;
            this.prompt = '';

            this.$emit('askAnswerLoading', { title: this.title, input: this.tempInput, answer: null, nospeech: true });

            const paramsData = {
                groupId: -1,
                code: 'znjn',
                question: this.tempInput,
                useLLM: this.$store.state.appSettings.useLLM
            };
            if (this.socket && this.socket.readyState === 1) {
                this.socket.send(JSON.stringify(paramsData));
            } else {
                this.initSocket(() => {
                    this.socket.send(JSON.stringify(paramsData));
                });
            }
        },
        wrap (event) {
            if (event.altKey) {
                this.prompt = this.prompt + '\n';
            }
        },
        ask (event) {
            if (event && !event.altKey) {
                this.send();
            }
        },
        getPrompt (input) {
            if (!this.promptTemplate) throw new Error('未找到提示词模板');
            let prompt = this.promptTemplate.content || '';
            prompt = prompt.replace(/\{input\}/g, input);
            return prompt;
        },
        selectValue (data) {
            this.$emit('setModel', data.value);
            this.prompt = this.prompt.replace(`/${data.value}`, '');
        },
        initSocket (cb) {
            if (this.socket && this.socket.connected) this.socket.close();
            const answerPrefix = '```gpt-chatbox-cop\n';
            this.socket = new WebSocket(`${this.wsOPEX}${this.sessionId}-x`);

            this.socket.onopen = () => {
                console.info('chatgpt-server WebSocket连接已打开');
                if (cb) {
                    return cb();
                }
                if (this.interval) {
                    clearInterval(this.interval);
                }
            };

            this.socket.onclose = () => {
                console.info('chatgpt-server WebSocket连接发生关闭');
                this.isSending = false;
            };

            this.socket.onmessage = async (event) => {
                if (event.data === '连接成功' || event.data === 'pong') {
                    return;
                }

                let text = event.data;

                console.info('智能节能回复：', event.data);

                let answer = '';

                if (isJson(text)) {
                    let json = JSON.parse(text);

                    // 打开网页、图表
                    if ((json.type === 'pop' && !!json.url) || (json.type === 'energyConservation' && !!json.url && !!json.chartType)) {
                        answer = answerPrefix + text + '\n```';
                    } else if (json.type === 'text') {
                        answer = typeof json.data === 'string' ? json.data : JSON.stringify(json.data);
                    } else {
                        answer = '未识别数据';
                    }
                } else {
                    answer = text;
                }
                this.$emit('askAnswerFinish', { title: this.title, input: this.tempInput, answer });

                this.isSending = false;
                this.socket.close();
                this.answer = '';
            };
        }
    },
    beforeDestroy () {
        if (this.socket) {
            this.socket.close();
        }
        this.$bus.$off('newChat:reflash');
        this.$bus.$off('shop:thisWs');
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
};
</script>

<style scoped lang="scss">
@import './gpt-chatbox-common.scss';
</style>
